import { createOhAuthApiClient } from '@oh-auth/api-client';
import { configState } from '../features/config';
import { selector } from 'recoil';

// export const ohAuthApiClient = createOhAuthApiClient(config);

export const apiClientState = selector({
	key: 'apiClient',
	get: ({ get }) => {
		const config = get(configState);
		return createOhAuthApiClient(config);
	},
});
